<template>
  <div class="column full-height">
    <div class="row justify-center">
      <img :src="headerImg" class="col-xs-5 col-sm-2 col-md-2" />
      <p class="text-weight-medium full-width text-center q-mt-md">
        So we can contact you we have your best contact number as:
      </p>
      <SAIFormError class="q-mt-md" v-if="contactNumberError.$error" />
      <SAIInput
        :disable="disable"
        class="q-mt-md col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4"
        placeholder="Enter mobile number"
        :large="true"
        :error="contactNumberError.$error"
        :value="user.contactNumber"
        @input="$emit('update:user', { ...user, contactNumber: $event })"
      />
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        :disable="disable"
        :loading="loading"
        label="Complete Profile"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import { SAIInput, SAIBtn, SAIFormError } from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfileContactNumber',
  props: {
    headerImg: String,
    disable: Boolean,
    loading: Boolean,
    contactNumberError: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    SAIInput,
    SAIBtn,
    SAIFormError,
    QSpace
  }
};
</script>
